import { RouteConfig } from 'vue-router';

const Ganyuku = () => import('./views/ganyuku/ganyuku.vue');
const Yingyangku = () => import('./views/yingyangku/yingyangku.vue');
const Xiyaoku = () => import('./views/xiyaoku/xiyaoku.vue');
const Jianyanku = () => import('./views/jianyanku/jianyanku.vue');
const Jianchaku = () => import('./views/jianchaku/jianchaku.vue');
const Kepuku = () => import('./views/kepuku/kepuku.vue');
const Yundongku = () => import('./views/yundongku/yundongku.vue');
const Zhibiaoku = () => import('./views/zhibiaoku/zhibiaoku.vue');
const ComposeKepuku = () => import('./views/compose-kepu/compose-kepu.vue');
const ComposeGanyuku = () => import('./views/compose-ganyu/compose-ganyu.vue');

const routers: RouteConfig[] = [
    {
        path: 'ganyuku',
        component: Ganyuku,
    },
    {
        path: 'yingyangku',
        component: Yingyangku,
    },
    {
        path: 'xiyaoku',
        component: Xiyaoku,
    },
    {
        path: 'jianyanku',
        component: Jianyanku,
    },
    {
        path: 'jianchaku',
        component: Jianchaku,
    },
    {
        path: 'kepuku',
        component: Kepuku,
    },
    {
        path: 'yundongku',
        component: Yundongku,
    },
    {
        path: 'zhibiaoku',
        component: Zhibiaoku,
    },
    {
        path: 'kepuku-compose-kepu',
        component: ComposeKepuku,
    },
    {
        path: 'ganyuku-compose-ganyu',
        component: ComposeGanyuku,
    },
    {
        path: '',
        redirect: 'Account'
    },

]
export default routers;
